import qs from 'qs'
import React, { useState, useEffect, useCallback, useContext } from "react"
import StatusIconText from "../../components/StatusIconText"
import { useNavigate } from "react-router-dom"
import axios from "axios"
import { LoadingPage } from "../AuxiliarPages/LoadingPage/LoadingPage"
import { ErrorPage } from "../AuxiliarPages/ErrorPage/ErrorPage"
import { NoAccessPage } from "../AuxiliarPages/NoAccessPage/NoAccessPage"
import { Pagination } from "../../components/Pagination"
import { DatetimeBlock } from "../../components/DatetimeBlock"
import { DataField } from "../../components/DataField"
import { FilterGroup } from "./FilterGroup/FilterGroup"
import { formatDateToISOZulu } from "../../utils/utils"
import { useCachedState } from "../../utils/useCachedState"
import AuthContext from "../../context/auth-context"
import { frontEnvelopeStatusToBack, frontRuleAnalysisStatus } from "../../utils/utils"
import ErrorBoundary from '../AuxiliarPages/ErrorBoundary/ErrorBoundary'
import BaseButton from '../../components/BaseButton'
import EnvelopeCreationDialog from './EnvelopeCreationDialog/index.js'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';

export const EnvelopeInbox = (props) => {

    const userRoles = useContext(AuthContext).user_data.roles
    const navigate = useNavigate()

    const openEnvelopeCreation = () => {
        setOpenEnvelopeCreationDialog(true)
    }

    const handleToast = (message, type) => {
        if (type === "success") {
            toast.success(message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            })
        } else if (type === "error") {
            let errorMessage = message ?? "Ocorreu um erro ao criar o envelope. Tente novamente."
            toast.error(errorMessage, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            })
        } else if (type === 'warning') {
            toast.warning(message, {
              position: "top-right",
              autoClose: 2500,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
          })
          }
    }



    const [fetchedData, setFetchedData] = useState(undefined)
    const [error, setError] = useState({
        hasError: false,
        statusCode: 200
    })
    const [loading, setLoading] = useState(true)
    const [filterLoading, setFilterLoading] = useState(false)
    const [maxPage, setMaxPage] = useState(0)
    const initialFilterState = {
        name: "",
        document_number: "",
        external_id: "",
        status: "",
        rule_analysis_status: "",
        initial_date: "",
        final_date: "",
        subject: ""
    }
    const initialConfigState = {
        params: {
            page_number: 0,
            page_rows: 7
        }
    }
    const [currentPage, setCurrentPage] = useCachedState("envelopeInboxCurrentPage", 0)
    const [filters, setFilters] = useCachedState("envelopeInboxFilters", initialFilterState)
    const [config, setConfig] = useCachedState("envelopeInboxConfig", initialConfigState)

    const [openEnvelopeCreationDialog, setOpenEnvelopeCreationDialog] = useState(false)

    const requestEnvelopes = useCallback(() => {
        setLoading(true)
        const timer = setTimeout(() => {
            setFilterLoading(true)
            const queryString = qs.stringify(config, { arrayFormat: 'repeat', encode: false }).replaceAll("params", "").replaceAll("[", "").replaceAll("]", "")
            axios.get(`/dash/sign/envelopes?${queryString}`)
                .then((response) => {
                    setFetchedData(response.data)
                    setMaxPage(response.data.pagination.number_of_pages)
                })
                .catch((error) => {
                    if ([404].includes((error.response || {}).status)) {
                        setError({
                            "has_error": true,
                            "status": error.response.status
                        })
                    } else {
                        setError({
                            "has_error": true,
                            "status": 500
                        })
                    }
                })
                .finally(() => {
                    setLoading(false)
                    setFilterLoading(false)
                })
        }, 500)
        return () => {
            clearTimeout(timer)
        }
    }, [config])

    useEffect(() => {
        let newConfig
        newConfig = config
        newConfig.params.page_number = currentPage
        setConfig(newConfig)
        requestEnvelopes()
    }, [currentPage, config, requestEnvelopes])

    const onFilter = useCallback(() => {
        setCurrentPage(0)
        let newConfig = {
            params: {
                page_number: 0,
                page_rows: 7
            }
        }
        Object.keys(filters).forEach((filter_key) => {
            if (filters[filter_key]) {
                if (filter_key === "document_number") {
                    newConfig.params[filter_key] = filters[filter_key].replaceAll(".", "").replaceAll("-", "").replaceAll(" ", "")
                } else if (filter_key === "name" || filter_key === "subject") {
                    newConfig.params[filter_key] = filters[filter_key].replaceAll(" ", "_").replaceAll(" ", "").toLowerCase()
                } else if (filter_key.includes("date")) {
                    const formattedDate = formatDateToISOZulu(filters[filter_key], filter_key)
                    if (formattedDate) {
                        newConfig.params[filter_key] = formattedDate
                    }
                } else if (filter_key === "status") {
                    newConfig.params[filter_key] = frontEnvelopeStatusToBack[filters[filter_key]].backStatus
                } else if (filter_key === "rule_analysis_status") {
                    newConfig.params[filter_key] = frontRuleAnalysisStatus[filters[filter_key]].backStatus
                }  
                else {
                    newConfig.params[filter_key] = filters[filter_key]
                }
            }
        })
        setConfig(newConfig)
    }, [filters])

    if (!userRoles.includes("list_envelopes")) {
        return (
            <NoAccessPage />
        )
    }
    if (loading) {
        return (
            <div className="page-container">
                <FilterGroup filters={filters} setFilters={setFilters} onFilter={onFilter} filterLoading={filterLoading} />
                <div className="page-container__toolbar">
                    <header>
                        <h1>
                            Listagem de Envelopes
                        </h1>
                    </header>
                </div>
                <LoadingPage />
            </div>
        )
    } else if (error.hasError) {
        return (
            <ErrorPage />
        )
    } else if (fetchedData) {
        return (
            <div className="page-container">
                <ToastContainer
                    position="top-center"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                />
                <FilterGroup filters={filters} setFilters={setFilters} onFilter={onFilter} filterLoading={filterLoading} />
                <div className="page-container__toolbar">
                    <header>
                        <h1>
                            Listagem de Envelopes
                        </h1>
                    </header>
                    {userRoles.includes("create_envelopes") &&
                        <BaseButton
                            label="Criar envelope"
                            onClick={() => openEnvelopeCreation()}
                            className="btn btn--animated btn--white"
                            isDisabled={false}
                        />}
                </div>
                {fetchedData.envelopes.length === 0 &&
                    <p className="message__container message__container--centered">
                        <span className="message__text">
                            Nenhum envelope
                        </span>
                    </p>}
                <ul className="inbox envelope-inbox-list row-click-list">
                    {fetchedData.envelopes.length !== 0 &&
                        <li className="inbox__header">
                            <div className="inbox__cell--left">Criado em:</div>
                            <div className="inbox__cell--center">Assinantes:</div>
                            <div className="inbox__cell--center">Observadores:</div>
                            <div className="inbox__cell--right">Status:</div>
                        </li>}
                    {fetchedData.envelopes.map((envelope) => (
                        <li
                            key={envelope.envelope_key}
                            className={`inbox__body${userRoles.includes("read_envelope") ? " inbox__body--clickable" : ""}`}
                        >
                            <ErrorBoundary>
                                {userRoles.includes("read_envelope") &&
                                    <a
                                        href={`/envelope/${envelope.envelope_key}`}
                                        className="envelope-row-link"
                                        aria-label="Ver detalhes do envelope"
                                        onClick={(e) => {
                                            if (
                                                e.ctrlKey ||
                                                e.metaKey ||
                                                e.button === 1
                                            ) {
                                                return;
                                            }
                                            e.preventDefault();
                                            navigate(`/envelope/${envelope.envelope_key}`);
                                        }}
                                    />}
                                <div className="inbox__cell--left inbox__cell--row-container">
                                    <DatetimeBlock dateString={envelope.created_at} />
                                    <div>
                                        <DataField
                                            label="Nome do Envelope"
                                            field={envelope.subject}
                                        />
                                        <DataField
                                            label="ID do Envelope"
                                            field={envelope.id}
                                        />
                                    </div>
                                </div>
                                <div className="inbox__cell--center">
                                    {envelope.signers.map((signer, index) => (
                                        <p
                                            className="inbox__cell--normal-text"
                                            key={`signer-${index}-${signer.document_number}`}
                                        >
                                            <span className="signer-name">{signer.name}</span>
                                            {signer?.document_number &&
                                                <span className="signer-document">{signer.document_number}</span>}
                                        </p>
                                    ))}
                                </div>
                                <div className="inbox__cell--center">
                                    {(envelope?.watchers || []).map((watcher, index) => (
                                        <p
                                            className="inbox__cell--normal-text"
                                            key={`watcher-${index}-${watcher.document_number}`}
                                        >
                                            <span className="signer-name">{watcher.name}</span>
                                            {watcher?.document_number &&
                                                <span className="signer-document">{watcher.document_number}</span>}
                                        </p>
                                    ))}
                                </div>
                                <div className="inbox__cell--right inbox__cell--row-container">
                                    <div className="inbox__cell--column-container" style={{ gap: ".4rem", alignItems: "flex-end" }}>
                                        <StatusIconText
                                            id={envelope.envelope_key}
                                            envelope_status={envelope.status}
                                            rule_analysis_status={envelope.rule_analysis_status}
                                            type="envelope_status"
                                        />
                                        <StatusIconText
                                            id={`${envelope.envelope_key}-rule-result`}
                                            rule_analysis_status={envelope.rule_analysis_status}
                                            envelope_status={envelope.status}
                                            type="rule_analysis_result"
                                        />
                                    </div>
                                </div>
                            </ErrorBoundary>
                        </li>
                    ))}
                </ul>
                <ErrorBoundary>
                    <Pagination
                        currentPage={currentPage}
                        maxPage={maxPage}
                        setCurrentPage={setCurrentPage}
                        maxVisiblePages={7}
                    />
                </ErrorBoundary>
                {openEnvelopeCreationDialog &&
                    <EnvelopeCreationDialog
                        open={openEnvelopeCreationDialog}
                        setOpen={setOpenEnvelopeCreationDialog}
                        handleToast={handleToast}
                        requestEnvelopes={requestEnvelopes}
                    />}
            </div>
        )
    }
}